import styled from "styled-components"
import {colors} from "../tokens"

export const Input = styled.input`
            width: 100%;
            box-sizing: border-box;
            padding: 11px 13px;
            margin-bottom: 0.9rem;
            border-radius: 0;
            font-weight: bold;
            outline: 0;
            border: 1px solid ${colors.grey7};
            border-radius: 2px;
            font-size: 20px;
            color: ${props=>props.textColor};
            transition: all 0.3s ease-out;
            :focus
             {
                border: 1px solid #1ca086;
                box-shadow: 0 0 5px 2px #1ca086, 0 1px 5px rgba(0, 0, 0, 0.1);
            }

`